import { Formik } from "formik";
import { Link, useHistory } from "react-router-dom";
import Button from "_shared/components/Button/Button";
import InputField from "../../_shared/components/InputField/InputField";
import { withAuth } from "../../_shared/contexts/AuthContext";
import { useModal } from "../../_shared/contexts/ModalContext";
import "./Reset.scss";

interface Props {
  forgotPassword: (_username: string) => Promise<void>;
}
export const Reset: React.FC<Props> = ({ forgotPassword }) => {
  const { onErrorMsg, onSuccessMsg } = useModal();
  const history = useHistory();

  async function reset({ username }: { username: string }) {
    try {
      await forgotPassword(username);
      onSuccessMsg(
        `We sent you an email with a link to reset your password.`,
        () => history.push("/login"),
      );
    } catch (err) {
      onErrorMsg(`We couldn't reset the password for that email address.`);
    }
  }

  return (
    <div id="reset-page">
      <div className="card">
        <div>
          <Link to="/login" style={{ textDecoration: "none" }}>
            <div
              style={{
                position: "relative",
                left: -10,
                width: 30,
                color: "#75ce41",
                fontSize: 25,
                cursor: "pointer",
              }}
            >
              ❮
            </div>
          </Link>

          <h2 className="forgot-password-text">Forgot your password?</h2>

          <p className="description-text">
            Please enter your email and we'll send you an email with a link to
            reset your password
          </p>
          <Formik onSubmit={reset} initialValues={{ username: "" }}>
            {({ handleSubmit }) => (
              <form onSubmit={handleSubmit}>
                <div
                  className="input-container"
                  style={{ marginBottom: "1rem" }}
                >
                  <InputField name="username" label="Email Address" />
                </div>
                <Button type="submit" fullWidth>
                  Reset Password
                </Button>
              </form>
            )}
          </Formik>
          <div className="dont-have-account-text">
            <div className="justify-center">Don't have an account yet?</div>
            <Link to="/signup" className="signup-link justify-center">
              SIGN UP
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
};

export default withAuth(Reset);
